// @generated by protoc-gen-es v2.2.3 with parameter "target=js+dts"
// @generated from file anu/cat_app/user.proto (package anu.cat_app, syntax proto3)
/* eslint-disable */

import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv1";
import { file_buf_validate_validate } from "../../buf/validate/validate_pb";
import { file_patch_go } from "../../patch/go_pb";

/**
 * Describes the file anu/cat_app/user.proto.
 */
export const file_anu_cat_app_user = /*@__PURE__*/
  fileDesc("ChZhbnUvY2F0X2FwcC91c2VyLnByb3RvEgthbnUuY2F0X2FwcCIUChJVc2VySXNBZG1pblJlcXVlc3QicwoTVXNlcklzQWRtaW5SZXNwb25zZRITCgtzdXBlcl9hZG1pbhgBIAEoCBIRCglvcmdfcm9sZXMYAiADKAkSGAoQY29sbGVnZV9vcmdfY29kZRgDIAMoCRIaChJhY2FkZW1pY19vcmdfY29kZXMYBCADKAkiKQoPR2V0VXNlcnNSZXF1ZXN0EhYKBXF1ZXJ5GAEgASgJQge6SARyAhADIjQKEEdldFVzZXJzUmVzcG9uc2USIAoFdXNlcnMYASADKAsyES5hbnUuY2F0X2FwcC5Vc2VyIlsKBFVzZXISDwoHdXNlcl9pZBgBIAEoCRIfCgRuYW1lGAIgASgLMhEuYW51LmNhdF9hcHAuTmFtZRIhCgVlbWFpbBgDIAEoCzISLmFudS5jYXRfYXBwLkVtYWlsIjQKBE5hbWUSDQoFZmlyc3QYASABKAkSDAoEbGFzdBgCIAEoCRIPCgdkaXNwbGF5GAMgASgJIhoKBUVtYWlsEhEKCWNhbm9uaWNhbBgBIAEoCUIzWitnaXRodWIuY29tL2FudS1pdHMvY2F0LWdycGMtYXBwLXBiO2NhdGFwcHBiyrUDAggBYgZwcm90bzM", [file_buf_validate_validate, file_patch_go]);

/**
 * Describes the message anu.cat_app.UserIsAdminRequest.
 * Use `create(UserIsAdminRequestSchema)` to create a new message.
 */
export const UserIsAdminRequestSchema = /*@__PURE__*/
  messageDesc(file_anu_cat_app_user, 0);

/**
 * Describes the message anu.cat_app.UserIsAdminResponse.
 * Use `create(UserIsAdminResponseSchema)` to create a new message.
 */
export const UserIsAdminResponseSchema = /*@__PURE__*/
  messageDesc(file_anu_cat_app_user, 1);

/**
 * Describes the message anu.cat_app.GetUsersRequest.
 * Use `create(GetUsersRequestSchema)` to create a new message.
 */
export const GetUsersRequestSchema = /*@__PURE__*/
  messageDesc(file_anu_cat_app_user, 2);

/**
 * Describes the message anu.cat_app.GetUsersResponse.
 * Use `create(GetUsersResponseSchema)` to create a new message.
 */
export const GetUsersResponseSchema = /*@__PURE__*/
  messageDesc(file_anu_cat_app_user, 3);

/**
 * Describes the message anu.cat_app.User.
 * Use `create(UserSchema)` to create a new message.
 */
export const UserSchema = /*@__PURE__*/
  messageDesc(file_anu_cat_app_user, 4);

/**
 * Describes the message anu.cat_app.Name.
 * Use `create(NameSchema)` to create a new message.
 */
export const NameSchema = /*@__PURE__*/
  messageDesc(file_anu_cat_app_user, 5);

/**
 * Describes the message anu.cat_app.Email.
 * Use `create(EmailSchema)` to create a new message.
 */
export const EmailSchema = /*@__PURE__*/
  messageDesc(file_anu_cat_app_user, 6);

